import React from 'react';
interface InvoiceTotalsProps {
  subtotal: number;
  gstTotal: number;
  totalDiscount: number;
  total: number;
  amountReceived: number;
  balanceDue: number;
}
export function InvoiceTotals({
  subtotal,
  gstTotal,
  totalDiscount,
  total,
  amountReceived,
  balanceDue
}: InvoiceTotalsProps) {
  const formatCurrency = (amount: number) => {
    return `$${amount.toFixed(2)}`;
  };
  return <div className="flex justify-end mb-3" data-id="element-587">
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 min-w-[380px] shadow-sm" data-id="element-588">
        <div className="space-y-2" data-id="element-589">
          <div className="flex justify-between items-center" data-id="element-590">
            <span className="text-xs font-medium text-neutral-600" data-id="element-591">
              Subtotal Before GST:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-592">
              {formatCurrency(subtotal)}
            </span>
          </div>

          <div className="flex justify-between items-center" data-id="element-593">
            <span className="text-xs font-medium text-neutral-600" data-id="element-594">
              GST 9%:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-595">
              {formatCurrency(gstTotal)}
            </span>
          </div>

          <div className="flex justify-between items-center" data-id="element-596">
            <span className="text-xs font-medium text-neutral-600" data-id="element-597">
              Total Discount:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-598">
              -{formatCurrency(totalDiscount)}
            </span>
          </div>

          <div className="h-px bg-neutral-200" data-id="element-599" />

          <div className="flex justify-between items-center" data-id="element-600">
            <span className="text-xs font-semibold text-neutral-700" data-id="element-601">
              Total Includes GST:
            </span>
            <span className="text-sm font-semibold text-neutral-900 tabular-nums" data-id="element-602">
              {formatCurrency(total)}
            </span>
          </div>

          <div className="h-px bg-neutral-200" data-id="element-603" />

          <div className="flex justify-between items-center" data-id="element-604">
            <span className="text-xs font-medium text-neutral-600" data-id="element-605">
              Less Amount Received:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-606">
              {formatCurrency(amountReceived)}
            </span>
          </div>

          <div className="h-px bg-neutral-300" data-id="element-607" />

          <div className="flex justify-between items-center bg-blue-50 border border-blue-200 -mx-4 px-4 py-2 rounded" data-id="element-608">
            <span className="text-sm font-bold text-neutral-900" data-id="element-609">
              Balance Due:
            </span>
            <span className="text-base font-bold text-blue-700 tabular-nums" data-id="element-610">
              {formatCurrency(balanceDue)}
            </span>
          </div>
        </div>
      </div>
    </div>;
}